import { Tab as ReachTab } from '@reach/tabs'
import cx from 'classnames'
import * as React from 'react'

import styles from './tab.module.scss'

export type Props = {
  children: React.ReactNode
  isSelected?: boolean
  index: number
}

const Tab = React.forwardRef(
  (props: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
    const { children, isSelected, ...otherProps } = props

    return (
      <ReachTab
        ref={ref}
        {...otherProps}
        className={cx(styles.tab, {
          [styles.active]: isSelected,
        })}
      >
        {children}
      </ReachTab>
    )
  },
)

export default Tab
